import {initOtherNewsSlider} from '../sections/other-news'; 
document.addEventListener('DOMContentLoaded', function() {
    initOtherNewsSlider();
});